/* Prepare an SMS draft; the visitor sends it from their messaging application. */
(() => {
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!ios) return;
  const prepare = root => root.querySelectorAll('a[data-dt-sms]').forEach(link => {
    const href = link.getAttribute('href');
    if (href?.startsWith('sms:') && href.includes('?body=')) link.setAttribute('href', href.replace('?body=', '&body='));
  });
  prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
